export const Welcome = () => (
  <section>
    <h1>Welcome Page</h1>
  </section>
);
